"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyApi = void 0;
const query_types_1 = require("../../query-modules/query-types");
const HTTP_METHOD_1 = require("../../../constants/HTTP_METHOD");
/**
 * @description Company API
 */
class CompanyApi {
    constructor(_connector, _verifyResponses) {
        this._connector = _connector;
        this._verifyResponses = _verifyResponses;
    }
    /**
     * @description
     * Get an index of companies
     */
    index(options) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const query = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
            const relations = (_b = options === null || options === void 0 ? void 0 : options.relations) !== null && _b !== void 0 ? _b : [];
            const extra = (_c = options === null || options === void 0 ? void 0 : options.extra) !== null && _c !== void 0 ? _c : [];
            const result = yield this._connector.apiFetchWithAuth(`/company?${query_types_1.queryString({
                query,
                relations,
                extra,
            })}`, HTTP_METHOD_1.HTTP_METHOD.GET);
            return result;
        });
    }
    /**
     * @description
     * Get a single company
     *
     *  T - placeholder for anything the consumer expects but isn't already provided
     *  R - resource relations
     */
    get(resourceId, options) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const query = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
            const relations = (_b = options === null || options === void 0 ? void 0 : options.relations) !== null && _b !== void 0 ? _b : [];
            const extra = (_c = options === null || options === void 0 ? void 0 : options.extra) !== null && _c !== void 0 ? _c : [];
            const result = yield this._connector.apiFetchWithAuth(`/company/${resourceId}?${query_types_1.queryString({
                query,
                relations,
                extra,
            })}`, HTTP_METHOD_1.HTTP_METHOD.GET);
            return result;
        });
    }
}
exports.CompanyApi = CompanyApi;
